import * as Yup from "yup";

export const detailRender = [
  [
    {
      name: "retailBarcode",
      label: "Retail Barcode",
      type: "text",
      errorMsg: "Retail Barcode is required.",
      required: true,
      // edit: true,
    },
    {
      name: "uomType",
      label: "UOM Type",
      type: "select",
      errorMsg: "UOM Type is required.",
      required: true,
    },
  ],
];

export const detailValue = {
  retailBarcode: null,
  uomType: null,
};

export const detailValidation = Yup.object().shape({
  retailBarcode: Yup.string().nullable().max(50).required("Retail Barcode is required."),
  uomType: Yup.string().nullable().required("UOM Type is required."),
});
